// Reducer that changes the state based on the action

import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const slice = createSlice({
  name: "subscription",
  initialState: {
    isLoading: false,
    data: [],
    userSubscription: null,
    userPaymentDetails: null,
    success: false,
    error: null,
    paymentSuccess: false,
    couponDetails:{}
  },
  reducers: {
    startFetching: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
      state.isLoading = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setData: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    setUserSubscription: (state, action) => {
      state.userSubscription = action.payload;
      state.isLoading = false;
    },
    setUserPayment: (state, action) => {
      state.userPaymentDetails = action.payload;
      state.isLoading = false;
    },
    setPaymentSuccess: (state, action) => {
      state.paymentSuccess = action.payload;
      state.isLoading = false;
    },
    setCouponDetails: (state, action) => {
      state.couponDetails = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  startFetching,
  setSuccess,
  setError,
  setData,
  setUserSubscription,
  setUserPayment,
  setPaymentSuccess,
  setCouponDetails
} = slice.actions;

export const useData = () => useSelector((state) => state.Subscription.data);
export const useUserSubscription = () => useSelector((state) => state.Subscription.userSubscription);
export const useUserPaymentDetails = () => useSelector((state) => state.Subscription.userPaymentDetails);
export const useIsLoading = () => useSelector((state) => state.Subscription.isLoading);
export const useSuccess = () => useSelector((state) => state.Subscription.success);
export const useError = () => useSelector((state) => state.Subscription.error);
export const usePaymentSuccess = () => useSelector((state) => state.Subscription.paymentSuccess);
export const useCouponDetails = () => useSelector((state) => state.Subscription.couponDetails);



export default slice.reducer;
